import { Injectable } from '@angular/core';
import { ResponseDialogTextKeyModel } from '@interfaces/ResponseDialogTextKeyModel';
import { Observable, Subject } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class ResponseDialogService {

	constructor() { }
	private subject = new Subject<any>();
	public open(textKeyModel: ResponseDialogTextKeyModel) {
		this.subject.next(
			{
				textKeyModel
			}
		);
	}

	public getResponseDialog(): Observable<any> {
		return this.subject.asObservable();
	}
}
